import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MG',
    name: 'Mariela G.',
    loc: '📍 Córdoba | Docente de Sociales Primaria',
    quote: 'Compré el PROFEPACK Sociales un domingo a la noche. El lunes tenía todo el año de Ciencias Sociales de primaria organizado. Nunca pensé que un material iba a ser tan completo. Las secuencias didácticas son exactamente lo que necesitaba: no tengo que pensar de cero para cada clase. Y el solucionario es un lujo — corrijo en minutos.'
  }, {
    initials: 'CR',
    name: 'Cecilia R.',
    loc: '📍 Mendoza | Docente de Sociales Primaria',
    quote: 'Lo que más me sorprendió fue que cada tomo tiene el solucionario integrado. Ya no pierdo tiempo preparando respuestas — todo está ahí. Mis colegas me preguntaron cómo tenía todo tan organizado y les conté. Ahora somos tres en la escuela que lo usamos.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    loc: '📍 Buenos Aires | Docente de Sociales Primaria',
    quote: 'El Kit de Efemérides me salvó la vida. El 25 de Mayo siempre era mi peor pesadilla. Con PROFEPACK resolví cada fecha en 30 minutos con actividades, texto y evaluación incluida. La directora me felicitó por cómo presenté la propuesta.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    loc: '📍 Tucumán | Docente de Sociales Primaria',
    quote: 'Lo que más valoro es que está organizado POR GRADO y alineado al currículo argentino. No tengo que adivinar qué le corresponde a 4° o a 5°. Todo ya está pensado, ordenado y listo. Es como tener un colega experto que ya hizo todo el trabajo por mí.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    loc: '📍 Rosario | Docente de Sociales Primaria',
    quote: 'Los mapas y recursos visuales del Bono 5 me cambiaron las clases de Geografía. Mis alumnos de 4° año por fin entienden las regiones de Argentina porque tienen el mapa en la mano, no solo mi explicación en el pizarrón.'
  }, {
    initials: 'VT',
    name: 'Valeria T.',
    loc: '📍 Santa Fe | Docente de Sociales Primaria',
    quote: 'Tengo grupos muy numerosos y poco tiempo. Las 30 Clases Salvavidas del Bono 2 me cambiaron la vida. Cuando tengo una semana difícil, abro una ficha y la clase funciona sola. Sin preparación extra. Sin estrés.'
  }];
  return <section className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-234">
      <div className="max-w-6xl mx-auto" data-id="element-235">
        <div className="text-center mb-20" data-id="element-236">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4 max-w-4xl mx-auto leading-tight" data-id="element-237">
            ⭐ TESTIMONIOS COMPLETOS
          </h2>
          <p className="text-xl text-brand-accent font-medium" data-id="element-238">
            +1.500 docentes de Argentina ya lo usan
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-239">
          {testimonials.map((test, i) => <div key={i} className="bg-brand-card rounded-3xl p-10 border border-brand-border" data-id="element-240">
              <div className="flex items-center gap-5 mb-8" data-id="element-241">
                <div className="w-16 h-16 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-2xl flex-shrink-0" aria-hidden="true" data-id="element-242">
                  {test.initials}
                </div>
                <div data-id="element-243">
                  <div className="text-brand-accent mb-2 text-sm" aria-label="5 estrellas" data-id="element-244">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="font-bold text-white text-xl mb-1" data-id="element-245">
                    {test.name}
                  </p>
                  <p className="text-sm text-white/70 font-medium" data-id="element-246">
                    {test.loc}
                  </p>
                </div>
              </div>
              <blockquote className="text-white/80 italic leading-relaxed text-lg" data-id="element-247">
                "{test.quote}"
              </blockquote>
            </div>)}
        </div>
      </div>
    </section>;
}